import { markPageJsExecuted } from "@faire/web/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { UPLTHookOptions } from "@faire/web/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";

import { useBrowseLayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useBrowseLayoutQuery";
import { useIsBrowseLayoutLoadedAndHasNoResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useIsBrowseLayoutLoadedAndHasNoResults";
import { useIsBrowseLayoutLoading } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useIsBrowseLayoutLoading";
import { useCategoryPageActionName } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useCategoryPageActionName";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";

const useIgnoreImages = () => {
  const isBrowseLayoutLoadedAndHasNoResults =
    useIsBrowseLayoutLoadedAndHasNoResults();
  const isBrowseLayoutError = useBrowseLayoutQuery().isError;

  return isBrowseLayoutLoadedAndHasNoResults || isBrowseLayoutError;
};

const pageJsExecutedMark = markPageJsExecuted();

export const useHubPageUPLT = (): Omit<UPLTHookOptions, "numComponents"> => {
  const { isError: isBrowseLayoutError, dataUpdatedAt: browseLayoutUpdatedAt } =
    useBrowseLayoutQuery();
  const pageName = useCategoryPageActionName();
  const isBrowseLayoutLoading = useIsBrowseLayoutLoading();
  const ignoreImages = useIgnoreImages();
  const navigationPath = useCurrentNavigationPath();

  return {
    name: pageName,
    isPageLoading: isBrowseLayoutLoading && !isBrowseLayoutError,
    ignoreImages,
    enableTrackPerformanceBreakdown: "internal-tracking",
    pageLoadKey: JSON.stringify(["HUB-PAGE-QUERY", navigationPath]),
    dataUpdatedAt: browseLayoutUpdatedAt,
    pageJsExecutedMark: pageJsExecutedMark,
  };
};
